import { cn } from "@/utils/cn";

const CollectionSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={cn("group/card animate-pulse", className)}>
      <div className={"relative"}>
        <div className={"bg-surface-bright aspect-square h-auto w-full rounded-[1.25rem]"} />
      </div>
    </div>
  );
};

export default CollectionSkeleton;
